export default __webpack_public_path__ + "static/media/14.f70b18bc.jpg";